import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Menu, X, ArrowUpRight, ChevronDown } from 'lucide-react';
import { BrandLink } from './Logo';
import { NAV, RESOURCES } from '../config/site';
import { EXT, openExternal } from '../config/links';
import { Cta } from './common';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [resOpen, setResOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll(); window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => { setOpen(false); setResOpen(false); }, [loc.pathname]);

  return (
    <header className="fixed top-0 inset-x-0 z-50 transition-all duration-300" style={{
      background: scrolled ? 'rgba(5,5,5,0.9)' : 'rgba(5,5,5,0.35)',
      backdropFilter: 'blur(16px)',
      borderBottom: `1px solid ${scrolled ? 'var(--border)' : 'transparent'}`,
    }}>
      <div className="container-x">
        <div className="flex items-center justify-between h-[74px]">
          <BrandLink height={38} />

          <nav className="hidden xl:flex items-center gap-1">
            {NAV.map((l) => (
              <NavLink key={l.to} to={l.to} className={({ isActive }) => `pill-nav ${isActive ? 'text-white' : ''}`}>{l.label}</NavLink>
            ))}
            <div className="relative" onMouseEnter={() => setResOpen(true)} onMouseLeave={() => setResOpen(false)}>
              <button className="pill-nav">Resources <ChevronDown size={14} /></button>
              {resOpen && (
                <div className="absolute top-full right-0 pt-2">
                  <div className="panel p-2 w-52" style={{ background: 'rgba(10,12,13,0.98)' }}>
                    {RESOURCES.map((r) => (
                      <NavLink key={r.to} to={r.to} className="block px-3 py-2.5 rounded-lg text-[14px] text-[var(--muted)] hover:text-white hover:bg-white/5 transition-colors">{r.label}</NavLink>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </nav>

          <div className="hidden xl:flex items-center gap-3">
            <button onClick={() => openExternal(EXT.LOGIN, 'login_click')} className="whitespace-nowrap text-[14.5px] text-[var(--muted)] hover:text-white transition-colors">Log In</button>
            <Cta size="sm" href={EXT.SIGNUP} onClick={() => openExternal(EXT.SIGNUP, 'signup_click')}>Start Trading <ArrowUpRight size={15} /></Cta>
          </div>

          <button className="xl:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">{open ? <X size={26} /> : <Menu size={26} />}</button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden border-t" style={{ borderColor: 'var(--border)', background: 'rgba(5,5,5,0.98)', backdropFilter: 'blur(16px)' }}>
          <div className="container-x py-6 flex flex-col gap-4 max-h-[80vh] overflow-y-auto">
            {[...NAV, ...RESOURCES].map((l) => (
              <NavLink key={l.to} to={l.to} className="text-[16px] text-[var(--text)]">{l.label}</NavLink>
            ))}
            <div className="gold-divider my-1" />
            <button onClick={() => openExternal(EXT.LOGIN, 'login_click')} className="flex items-center gap-1.5 text-[16px] text-[var(--muted)]">Log In <ArrowUpRight size={16} /></button>
            <Cta href={EXT.SIGNUP} onClick={() => openExternal(EXT.SIGNUP, 'signup_click')} className="w-full">Start Trading</Cta>
          </div>
        </div>
      )}
    </header>
  );
}
